import { FabricObject, StaticCanvas, Textbox } from 'fabric';
import { walkObjects } from '../../canvas/utils/walk-objects';

export interface FitToContentConfig {
  paddingX?: number;
  minWidth?: number;
}

/** Adjusts a Textbox width to match its content. */
export function fitToContent(textbox: Textbox, cfg: FitToContentConfig = {}): void {
  const padX = cfg.paddingX ?? 0;
  const textWidth = textbox.calcTextWidth?.() ?? 0;
  const width = Math.max(textWidth + 2 * padX, cfg.minWidth ?? 0);
  textbox.set({ width });
  textbox.initDimensions?.();
}

/** Reads and validates the fit-to-content configuration. */
function readFitToContent(obj: FabricObject): FitToContentConfig | undefined {
  const cfg = obj.fitToContent;
  if (!cfg || typeof cfg !== 'object') return undefined;
  return cfg;
}

/** Updates all configured Textboxes in the canvas, including those inside Groups. */
export function applyAllFitToContent(canvas: StaticCanvas): void {
  walkObjects(canvas, obj => {
    if (!(obj instanceof Textbox)) return;
    const cfg = readFitToContent(obj);
    if (!cfg) return;
    fitToContent(obj, cfg);
  });
}
